import React, { useState } from 'react';

import style from './radioselect.module.css';
import bottomin from '../../img/bottom_in.svg';
import selectedbtn from '../../img/selectedgroup.svg'

const Radioselect = ({options,hobbyz,setHobby}) => {
 
  const [isOpen, setIsOpen] = useState(false);

  const handleSelect = (option) => {
    if (hobbyz.includes(option)) {
      setHobby(hobbyz.filter((item) => item !== option));
    } else {
      if (hobbyz.length >= 4) {
        
      } else {
        setHobby([...hobbyz, option]);
      }
    }
  };
  const pluralize = (number, one, two, many) => {
    if (number % 10 === 1 && number % 100 !== 11) {
      return one;
    }
    if (number % 10 >= 2 && number % 10 <= 4 && (number % 100 < 10 || number % 100 >= 20)) {
      return two;
    }
    return many;
  };
  
  return (
    <div className={style.customSelect}>
      <div className={style.selected} onClick={() => setIsOpen(!isOpen)}>
        {hobbyz.length > 0 ? ` ${pluralize(hobbyz.length, 'Выбран', 'Выбрано', 'Выбрано')} ${hobbyz.length} ${pluralize(hobbyz.length, 'элемент', 'элемента', 'элементов')}` : 'Нажмите для выбора'}
        <img src={bottomin} className={isOpen ? style.transselect : null} alt=''/>
      </div>
      {isOpen && (
        <div className={style.options}>
          {options.map((option) => (
            (hobbyz.includes(option) ? 
            <div key={option} className={style.option} onClick={() => handleSelect(option)}>
              {option}
              <img src={selectedbtn} alt='' />
            </div>
            :
            <div key={option} className={style.option} onClick={() => handleSelect(option)}>
              {option}
            </div>
            )
          ))}
        </div>
      )}
    </div>
  );
};
export default Radioselect;